import React from 'react';
import style from './Education.module.scss';
import ClickViewLogoImg from '../imgs/clickview.jpg';
import WorkshopPhotoImg from '../imgs/U and Me Dave and John 28 RGB website.jpg';

const Education = () => (
    <section className={style.eduSection} id="education">
        <div className="wrap">
            <div className={`section-head ${style.sectionHead}`}>
                <div className="eyebrow">For educators &amp; communities</div>
                <h2>Take the stories further.</h2>
            </div>
            <div className={style.eduGrid}>
                <div className={style.eduCard}>
                    <div className={style.eduLogo}><img src={ClickViewLogoImg} alt="ClickView" /></div>
                    <h3>Education</h3>
                    <p>Yesterday Stories has a distribution deal with ClickView, the number one video storytelling platform linked to curriculum, used in 1 in every 2 schools. Teachers can find and play Yesterday Stories through ClickView for history lessons — our 3–5 minute stories are perfect and engaging for young people to understand history quickly and succinctly.</p>
                </div>
                <div className={style.eduCard}>
                    <div className={style.workshopPhoto}><img src={WorkshopPhotoImg} alt="Film-making workshop" /></div>
                    <h3>Film-making workshops</h3>
                    <p>Book our team to work with your community and young people to produce their own stories. See some feedback on workshops we've run through school holidays. Contact us now to book school holiday workshops or to find out more about how to partner with us.
</p>
                </div>
            </div>
            <div className={style.eduCtaRow}>
                <a href="mailto:info@yesterdaystories.com.au" className={style.btnPrimary}>Contact us for more information</a>
            </div>
        </div>
    </section>
);

export default Education;
